import { Button } from '@/_components';

export function FilterApplyTrigger({ handleSubmit, isPending }: { handleSubmit: () => void; isPending: boolean }) {
  return (
    <div className="mt-6 mb-4">
      <Button showLoader={isPending} size="sm" onClick={handleSubmit}>
        Apply
      </Button>
    </div>
  );
}
